import { Exception } from 'common/exceptions/Exception';
import { SupportedOfficeItem } from 'common/utils/SupportedOfficeItem';
import CONFIG from 'config';
import $ from 'jquery';
import * as App from '../app/app';
import { AddInStakeholder } from '../models/AddInStakeholder';
import { DomainDetails } from '../models/DomainDetails';
import { Option } from '../models/Option';
import { ProjectInfo } from '../models/ProjectInfo';
import { Region } from '../models/Region';
import { Stakeholder } from './../models/Stakeholder';
import { getPrimaryStakeholders } from './contactUtils';
import * as OutlookAsyncUtils from './outlookAsyncUtils';
import * as UserSettings from './user-settings';

const TAG = 'AUI3: ';
export function showMessageAutosaved() {
  $('#was-autosaved-page').show();
}

export function showMessageSaved() {
  $('#was-saved-page').show();
}

export function showSeriesEventNotSupported() {
  $('#series-event-not-supported-page').show();
}

export function showReadOnlySharedItemNotSupported() {
  $('#read-only-shared-item-not-supported-page').show();
}

export async function showPrimaryStakeholdersInfo(item: SupportedOfficeItem) {
  const sharedProperties = await OutlookAsyncUtils.getSharedProperties(item);
  const primaryStakeholders = await getPrimaryStakeholders(
    item,
    sharedProperties
  );

  const names = primaryStakeholders.map((s) => s.fullName).join('<br/>');
  const emails = primaryStakeholders.map((s) => s.email).join('<br/>');

  changeLabelsByItemType(item);

  if (
    !CONFIG.isGraphApiEnabled ||
    item.itemType === 'appointment' ||
    sharedProperties
  ) {
    $('#autoSaveAll').hide();
    $('#autoSaveAllLabel').hide();
    $('#autoSaveAll').removeAttr('checked');

    $('#autoSaveOne').attr('checked', 'checked');
    UserSettings.setAutosave(false);
  }

  $('#detail-page').show();

  $('#user-id').html(names);
  $('#user-sub-text').html(emails);
}

export function showStakeholdersForm(
  primaryStakeholders: AddInStakeholder[],
  additionalStakeholders: AddInStakeholder[],
  itemType: string
) {
  if (itemType === 'appointment') {
    $('#primary-stakeholder-detail').hide();
    $('#save-all-or-primary').hide();
    $('#save-or-cancel-buttons-1').hide();
    $('#cc-bcc-email-main').show();
    $('#cc-bcc-email-main').html('Stakeholders:');
    showAllStakeholders(primaryStakeholders);
    $('input[name="save-all-future-email"]:checked').val('all');
  } else {
    const primaryStakeholder = primaryStakeholders[0];
    $('#item-from').val(primaryStakeholder.email);
    $('#item-org2').val(primaryStakeholder.fullName);
    $('#item-from-fname').val(primaryStakeholder.firstName);
    $('#item-from-lname').val(primaryStakeholder.lastName);

    showAdditionalStakeholders(additionalStakeholders);
  }
}

export function showAdditionalStakeholders(stakeholders: AddInStakeholder[]) {
  let additionalStakeholdersHtml = '';

  let index = 0;
  stakeholders.forEach((stakeholder) => {
    additionalStakeholdersHtml += getStkFormAdd(index++, stakeholder, false);
  });

  $('#cc-bcc-emails').html(additionalStakeholdersHtml);

  if (stakeholders.length > 0) {
    $('#cc-bcc-email-main').show();
    $('#secondSubmit').show();
  } else {
    $('#cc-bcc-email-main').hide();
    $('#secondSubmit').hide();
  }
}

export function showAllStakeholders(stakeholders: AddInStakeholder[]) {
  let additionalStakeholdersHtml = '';

  let index = 0;
  stakeholders.forEach((stakeholder) => {
    additionalStakeholdersHtml += getStkFormAdd(index++, stakeholder, true);
  });

  $('#cc-bcc-emails').html(additionalStakeholdersHtml);

  if (stakeholders.length > 0) {
    $('#secondSubmit').show();
  } else {
    $('#secondSubmit').hide();
  }
}

function getStkFormAdd(
  index: number,
  stakeholder: AddInStakeholder,
  showCheckboxes: boolean
) {
  let html =
    '<div class="cc-bcc-single-details">\
                <table class="table">';

  if (showCheckboxes) {
    html +=
      '<tr>\
         <td class="label">Save this stakeholder</td>\
         <td><input type="checkbox" class="cc-check" data-id="' +
      index +
      '"  placeholder="" checked  name="cc-check' +
      index +
      '" id="cc-check' +
      index +
      '"/></td>\
       </tr>';
  }
  html +=
    '<tr>\
              <td class="label">Individual/Organisation</td>\
              <td>\
                  <div class="select-wrap">\
                      <span class="down-arrow"></span>\
                      <select class="form-controller cc-bcc-select cc_stakeholder_type" data-id="' +
    index +
    '" id="cc_stakeholder_type' +
    index +
    '" name="cc_stakeholder_type' +
    index +
    '">\
                          <option value="Individual">Individual</option>\
                          <option value="Organisation">Organisation</option>\
                      </select>\
                  </div>\
              </td>\
          </tr>\
          <tr>\
              <td class="label">Email</td>\
              <td class="emailaddress">' +
    stakeholder.email +
    '</td>\
          </tr>\
          <tr class="table-indi-fields">\
              <td class="label">First Name</td>\
              <td>\
                  <div class="input-field">\
                      <input type="text" class="form-controller cc-bcc-fname" placeholder="" value="' +
    stakeholder.firstName +
    '" id="cc-bcc-fname' +
    index +
    '" name="cc-bcc-fname' +
    index +
    '"/>\
                  </div>\
              </td>\
          </tr>\
          <tr class="table-indi-fields">\
              <td class="label">Last Name</td>\
              <td>\
                  <div class="input-field">\
                      <input type="text" class="form-controller cc-bcc-lname" placeholder="" value="' +
    stakeholder.lastName +
    '" id="cc-bcc-lname' +
    index +
    '" name="cc-bcc-lname' +
    index +
    '"/>\
                  </div>\
              </td>\
          </tr>\
          <tr class="table-indi-fields">\
              <td class="label">Organisation</td>\
              <td>\
                  <div class="input-field">\
                      <input type="text" class="form-controller cc-bcc-org" placeholder="" value=""' +
    ' id="cc-bcc-org' +
    index +
    '" name="cc-bcc-org' +
    index +
    '"/>\
                  </div>\
              </td>\
          </tr>\
          <tr class="table-org-fields" style="display: none;">\
              <td class="label">Organisation</td>\
              <td>\
                  <div class="input-field">\
                      <input type="text" class="form-controller cc-bcc-org2" placeholder="" value="' +
    stakeholder.fullName +
    '" id="cc-bcc-org2' +
    index +
    '" name="cc-bcc-org2' +
    index +
    '"/>\
                  </div>\
              </td>\
          </tr>\
          <tr class="table-indi-fields">\
              <td class="label">Position</td>\
              <td>\
                  <div class="input-field">\
                      <input type="text" class="form-controller cc-bcc-pos" placeholder=""' +
    ' value="" id="cc-bcc-pos' +
    index +
    '" name="cc-bcc-pos' +
    index +
    '"/>\
                  </div>\
              </td>\
          </tr>\
          <tr class="">\
              <td class="label">Phone</td>\
              <td>\
                  <div class="input-field">\
                      <input type="text" class="form-controller cc-bcc-mobile" placeholder=""' +
    '  value="" id="cc-bcc-mobile' +
    index +
    '" name="cc-bcc-mobile' +
    index +
    '"/>\
                  </div>\
              </td>\
          </tr>\
      </table>\
  </div>';

  return html;
}

export function getStakeholdersFromUi() {
  const stakeholders = Array<Stakeholder>();
  const itemEmail = getStringValueOrNull('#item-from');
  const itemPos = getStringValueOrNull('#item-pos');
  const contactGroupsArray = getMultiSelectValues('#item-contact-group');
  const stakeholderType = getStringValueOrNull('#select-individual-main');
  let itemOrg = getStringValueOrNull('#item-org');
  if (stakeholderType != 'Individual') {
    itemOrg = getStringValueOrNull('#item-org2');
  }
  const fname = getStringValueOrNull('#item-from-fname');
  const lname = getStringValueOrNull('#item-from-lname');
  const itemMobile = getStringValueOrNull('#item-mobile');

  const primaryStakeholder: Stakeholder = {
    ID: undefined,
    StakeholderType: stakeholderType,
    FirstName: stakeholderType != 'Individual' ? itemOrg : fname,
    LastName: lname,
    Email: itemEmail,
    ContactGroupIDs: contactGroupsArray,
    Organisations: [
      {
        Name: stakeholderType != 'Individual' ? '' : itemOrg,
        Position: stakeholderType != 'Individual' ? '' : itemPos,
      },
    ],
    MobileNumber: undefined,
    WorkPhoneNumber: undefined,
  };
  if (stakeholderType != 'Individual') {
    primaryStakeholder.WorkPhoneNumber = itemMobile;
  } else {
    primaryStakeholder.MobileNumber = itemMobile;
  }

  if (primaryStakeholder.Email) {
    stakeholders.push(primaryStakeholder);
  }

  if ($('input[name="save-all-future-email"]:checked').val() == 'all') {
    $('.cc-bcc-single-details').each(function () {
      const saveCheckbox = $(this).find('.cc-check');
      if (saveCheckbox.length > 0 && !saveCheckbox.prop('checked')) {
        return;
      }

      const itemEmailTo = $(this).find('.emailaddress').html();
      let itemOrgTo = '';
      if ($(this).find('.cc_stakeholder_type').val() == 'Individual') {
        itemOrgTo = $(this).find('.cc-bcc-org').val().toString();
      } else {
        itemOrgTo = $(this).find('.cc-bcc-org2').val().toString();
      }
      const itemPosTo = $(this).find('.cc-bcc-pos').val().toString();
      const itemMobileTo = $(this).find('.cc-bcc-mobile').val().toString();
      const StakeholderTypeTo = $(this)
        .find('.cc_stakeholder_type')
        .val()
        .toString();
      const fnameTo = $(this).find('.cc-bcc-fname').val().toString();
      const lnameTo = $(this).find('.cc-bcc-lname').val().toString();
      const additionalStakeholder: Stakeholder = {
        ID: undefined,
        StakeholderType: StakeholderTypeTo,
        FirstName: StakeholderTypeTo != 'Individual' ? itemOrgTo : fnameTo,
        LastName: lnameTo,
        Email: itemEmailTo,
        ContactGroupIDs: contactGroupsArray,
        Organisations: [
          {
            Name: StakeholderTypeTo != 'Individual' ? '' : itemOrgTo,
            Position: StakeholderTypeTo != 'Individual' ? '' : itemPosTo,
          },
        ],
        MobileNumber: undefined,
        WorkPhoneNumber: undefined,
      };
      if (StakeholderTypeTo != 'Individual') {
        additionalStakeholder.WorkPhoneNumber = itemMobileTo;
      } else {
        additionalStakeholder.MobileNumber = itemMobileTo;
      }
      stakeholders.push(additionalStakeholder);
    });
  }
  return stakeholders;
}

function changeLabelsByItemType(item: SupportedOfficeItem) {
  if (item.itemType === 'appointment') {
    const labels = [
      '#login-text',

      '#autoSaveAllLabel',
      '#autoSaveOneLabel',

      '#save-email-detail',
      '#save-email-detail2',

      '#item-saved-successfully',
    ];

    let tooltip = $('#futureAllTooltip').attr('title');
    if (tooltip) {
      tooltip = tooltip.replace('email', 'event');
    }
    $('#futureAllTooltip').attr('title', tooltip);

    $('#div-interaction-method').hide();

    labels.forEach((l) => changeLabelByItemType(l));
  }
}

function changeLabelByItemType(id: string) {
  let currentLabel = $(id).html();
  if (currentLabel) {
    currentLabel = currentLabel.replace('email', 'event');
    currentLabel = currentLabel.replace('Email', 'Event');
  }
  $(id).html(currentLabel);
}

export function setIcon(path: string, width: number) {
  $('#header-logo').attr('width', width);
  $('#header-logo').attr('src', path);
}

export function setAppName(name: string) {
  const elements = ['#login-text', '#item-saved-successfully'];
  for (const el of elements) {
    setAppNameInElement(el, name);
  }
}

export function setFreeTrialUrl(url: string) {
  const id = '#login-text__free-trial';
  $(id).attr('href', url);
}

export function setOptions(
  isComplaintsEnabled: boolean,
  isConfidentialOptionsEnabled: boolean
) {
  if (isComplaintsEnabled) $('#div-interaction-method').show();
  else $('#div-interaction-method').hide();

  if (isConfidentialOptionsEnabled) $('#form-confidentiality').show();
  else {
    $('#form-confidentiality').hide();
  }
}

function setAppNameInElement(id: string, name: string) {
  let html = $(id).html();
  html = html.replace(/APP_NAME/g, name);
  $(id).html(html);
}

export function renderOptions(
  options: Option[],
  selector: string,
  addEmptyOption = false
) {
  let html = '';
  if (addEmptyOption) {
    html = '<option value="" selected>None</option>';
  }

  options.forEach(function (item) {
    html += '<option value="' + item.Value + '">' + item.Text + '</option>';
  });

  $(selector).html(html);

  if (html == '') {
    $(selector.replace('#', '.') + '-main').hide();
  } else {
    $(selector.replace('#', '.') + '-main').show();
  }
}

export function showRegions(regions: Region[]) {
  const regionSelect = $('#select-domain-login');

  const domain = UserSettings.getDomain();

  let selected = false;
  let options = '';
  regions.forEach(function (item) {
    if (domain == item.api_url) {
      selected = true;
      options +=
        '<option value="' +
        item.api_url +
        '" selected>' +
        item.label +
        '</option>';
    } else {
      options +=
        '<option value="' + item.api_url + '">' + item.label + '</option>';
    }
  });

  if (!selected) {
    options =
      '<option value="" disabled selected>Select Region</option>' + options;
  }

  regionSelect.html(options);
}

export function showErrorInForm(message: string, error?: Exception) {
  $('#loader').hide();

  $('#error__message-details').hide();

  if (error) {
    let errorDetails: string;
    if (error instanceof Error) {
      // instance of "Error" cannot be stringified, just show the stack. it will include the error message.
      errorDetails = error.stack;
    } else {
      errorDetails = JSON.stringify(error);
    }

    $('#error__message-details').html('<br/>' + errorDetails);

    $('#error__btn-details').show();
  } else {
    $('#error__btn-details').hide();
  }
  $('#error__message').html(message);

  $('#error-dialog').show();
}

export function showInfoDialog(message: string) {
  $('#loader').hide();
  $('#dialog-info p').html(message);
  $('#dialog-info').show();
}

export function hideInfoDialog() {
  $('#dialog-info').hide();
}

export function showAuthErrorDialog(message: string | null) {
  $('#loader').hide();
  $('#detail-save-error p').html(message);
  $('#detail-save-error').show();
}

export function showLogoutSuccessDialog() {
  $('#loader').hide();
  $('#dialog-logout-success').show();
}

export function refreshDomains(
  domains: DomainDetails[],
  favouriteDomainAndGroup: ProjectInfo,
  projectGroupAvailable: boolean
) {
  let domainOption = '';
  if (domains.length > 1) {
    domainOption = '<option value="" disabled selected>select domain</option>';
  }
  if (favouriteDomainAndGroup) {
    domainOption = '<option value="" disabled >select domain</option>';
  }
  for (let index = 0; index < domains.length; index++) {
    domainOption +=
      '<option value="' +
      domains[index].ID +
      '"' +
      '>' +
      domains[index].DomainName +
      '</option>';
  }
  $('#save-domain').html(domainOption);
  if (favouriteDomainAndGroup) {
    $('#save-domain').val(favouriteDomainAndGroup.domainId).trigger('change');
    if (projectGroupAvailable) {
      $('#save-proj-group')
        .val(favouriteDomainAndGroup.projectGroupId)
        .trigger('change');
    }
    $('#save-project').val(favouriteDomainAndGroup.projectId).trigger('change');
  } else {
    const domainOptions = $('#save-domain').find('option');
    // select the first domain OR the placeholder option
    const defaultOption =
      domainOptions.length > 1 ? domainOptions[1] : domainOptions[0];

    defaultOption.setAttribute('selected', 'true');
    $('#save-domain').trigger('change');
  }

  $('#form-domain').show();
  $('#ProjectGroupContainer').show();
  $('#form-project').show();

  // if there is only one domain, hide the dropdown
  if (domains.length == 1) {
    $('#form-domain').hide();
    const domain = domains[0];

    if (projectGroupAvailable) {
      const groupsWithAccessibleProjects = domain.ProjectGroups.filter(
        (g) => g.Projects && g.Projects.length
      );
      // if there is only one project group, select it and hide the dropdown
      if (groupsWithAccessibleProjects.length == 1) {
        const group = groupsWithAccessibleProjects[0];
        if (!favouriteDomainAndGroup) {
          $('#save-proj-group').val(group.ID).trigger('change');
        }
        $('#ProjectGroupContainer').hide();

        // if there is only one project within the only one project group, hide the dropdown and select the project
        if (group.Projects.length == 1 && !favouriteDomainAndGroup) {
          $('#form-project').hide();
          $('#save-project').val(group.Projects[0].ID).trigger('change');
        }
      }
    } else {
      $('#ProjectGroupContainer').hide();
      // if no project groups and there is only one project, hide the dropdown and select the project
      if (domain.Projects.length == 1 && !favouriteDomainAndGroup) {
        $('#form-project').hide();
        $('#save-project').val(domain.Projects[0].ID).trigger('change');
      }
    }
  }
}

export function checkSaveForm(): boolean {
  console.log(TAG, 'Validating the form');
  const projectGroup = $('#save-proj-group').val();
  const project = $('#save-project').val();
  let priorities = false;
  let assignedTo = false;
  if ($('#item-communication').val() == 'Complaint') {
    priorities = $('#complaint-priorities').val() ? false : true;
    assignedTo = $('#item-assigned-to').val() ? false : true;
  }

  if (
    (projectGroup == null || projectGroup == '') &&
    App.projectGroupAvailable
  ) {
    $('#project-group-error').html('Please select Project Group');
    $('#save-proj-group').focus();
    console.log(TAG, 'Validation not passed: project group');
    return false;
  } else if (project == null || project == '') {
    $('#project-group-error').html('');
    $('#project-error').html('Please select Project');
    $('#save-project').focus();
    console.log(TAG, 'Validation not passed: project');
    return false;
  } else if (CONFIG.isComplaintsEnabled && assignedTo) {
    $('#item-assigned-to-error').html('Please select Assign To');
    $('#item-assigned-to').focus();
    console.log(TAG, 'Validation not passed: item assigned to');
    return false;
  } else if (CONFIG.isComplaintsEnabled && priorities) {
    $('#complaint-priorities-error').html('Please select Complaint Priorities');
    $('#complaint-priorities').focus();
    console.log(TAG, 'Validation not passed: complaint priorities');
    return false;
  } else {
    $('#project-group-error').html('');
    $('#project-error').html('');
    $('#item-assigned-to-error').html('');
    $('#complaint-priorities-error').html('');
    console.log(TAG, 'Validation passed');
    return true;
  }
}

export function hidePages() {
  $('#welcome-pg').hide();

  $('#series-event-not-supported-page').hide();
  $('#was-saved-page').hide();
  $('#was-autosaved-page').hide();

  $('#login-page').hide();
  $('#detail-page').hide();
  hideDocumentDetailsPage();
  $('#detail-final').hide();
  $('#item-not-supported-page').hide();
}

function getStringValueOrNull(id: string) {
  const value = $(id).val();
  if (value) {
    return value.toString();
  } else {
    return null;
  }
}

function getMultiSelectValues(id: string): string[] {
  const data = $(id).select2('data');

  return data.map((value) => value.id);
}

export function hideDocumentDetailsPage() {
  $('#detail-final').hide();
}

export function showSaveSuccessfulDialog() {
  $('#detail-save-pop').show();
}

export function hideSaveSuccessfulDialog() {
  $('#detail-save-pop').hide();
}

export function showItemNotSupportedPage() {
  $('#item-not-supported-page').show();
}
